function labelTables() {
  document.querySelectorAll('table').forEach(function (table) {
    var ths = table.querySelectorAll('thead th');
    if (!ths.length) return;
    var labels = Array.from(ths).map(function (th) { return th.innerText.trim(); });
    table.classList.add('mobile-cards');
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      Array.from(tr.children).forEach(function (td, i) {
        var l = labels[i] || '';
        if (td.getAttribute('data-label') !== l) td.setAttribute('data-label', l);
      });
    });
  });
}
var pending = false;
new MutationObserver(function () {
  if (pending) return;
  pending = true;
  requestAnimationFrame(function () { pending = false; labelTables(); });
}).observe(document.documentElement, { childList: true, subtree: true });
labelTables();
